import gql from 'graphql-tag';

/**
 * Mutation to remove a section from an inspection template.
 */
export const removeSectionFromTemplateMutation = gql`
  mutation RemoveSectionFromTemplate($input: RemoveSectionFromTemplateInput!) {
    removeSectionFromTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
